import Link from "next/link";

import classNames from "classnames";
import { twMerge } from "tailwind-merge";

import { faGem } from "@fortawesome/free-regular-svg-icons/faGem";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import PremiumServiceButton from "components/PremiumServiceButton";

type PremiumServiceWidgetProps = {
  profile: any;
  showCTA?: boolean;
  isInsightWidget?: boolean;
  insight?: any;
};

const PremiumServiceWidget = ({
  profile,
  showCTA,
  isInsightWidget,
  insight,
}: PremiumServiceWidgetProps) => {
  if (isInsightWidget) {
    return (
      <div className="flex flex-col items-center justify-center text-center">
        <div className="w-[80px] h-[80px] flex items-center rounded-full justify-center bg-[#05BDD9]/20 mb-[10px]">
          <FontAwesomeIcon
            icon={faGem}
            className="text-[46px] text-[#05BDD9] mt-[5px]"
          />
        </div>
        <div
          className={classNames(
            "font-[500] md:font-[900]",
            "text-[22px]",
            "text-active-black tracking-[0.44px] mb-[5px] md:mb-[10px]"
          )}
        >
          {profile?.shortName}&apos;s Premium Subscriptions
        </div>
        <div className="text-[18px] mb-[23px]">
          Get high-touch access to {profile?.shortName} and their specialist
          services.
        </div>

        {profile.showPremiumServicesTab && !showCTA ? (
          <div className="text-[18px]">
            <Link
              href={`/${profile.isCompany ? "companies" : "profiles"}/${
                profile.slug
              }/premium-subscriptions`}
              className="text-[18px] font-bold text-smart-teal hover:text-[#00b5d0]"
            >
              Learn more
            </Link>{" "}
            about {profile.shortName}&apos;s Premium Subscriptions.
          </div>
        ) : (
          <>
            <PremiumServiceButton
              profile={profile}
              className={classNames(
                "border border-solid border-smart-teal rounded-full",
                "w-full max-w-[300px] h-[38px]",
                "text-[16px] font-bold text-white bg-gradient-130 from-smart-teal to-jade hover:from-dark-teal hover:to-dark-jade transition-all"
              )}
              parameters={{
                origin: "insight",
                insightId: insight?.id,
                source: "web",
              }}
            >
              {!showCTA && (
                <FontAwesomeIcon
                  icon={faGem}
                  className="text-[16px] text-white"
                />
              )}{" "}
              Request Information/Trial
            </PremiumServiceButton>
            <div className="text-[12px] mt-[10px]">
              <Link
                href={`/${profile.isCompany ? "companies" : "profiles"}/${
                  profile.slug
                }/premium-subscriptions`}
                className="text-[13px] font-bold text-smart-teal hover:text-[#00b5d0]"
              >
                Learn more
              </Link>{" "}
              about {profile.shortName}&apos;s Premium Subscriptions.
            </div>
          </>
        )}
      </div>
    );
  }

  if (showCTA) {
    return (
      <div className="p-[15px]">
        <h2 className={twMerge("font-medium", "text-[16px]", "text-[#1f1f20]")}>
          Premium Subscriptions
        </h2>
        {profile.premiumServiceCatalogues?.[0].title}
        <div className="text-center">
          <PremiumServiceButton
            profile={profile}
            className={classNames(
              "border border-solid border-smart-teal rounded-full",
              "px-[30px] h-[38px]",
              "text-smart-teal text-[16px] font-bold bg-white hover:text-white hover:bg-smart-teal",
              "mt-[15px]"
            )}
          >
            Request Information/Trial
          </PremiumServiceButton>
        </div>
      </div>
    );
  }

  return (
    <div className="px-[31px] py-[25px] text-center">
      <FontAwesomeIcon
        icon={faGem}
        className="text-[46px] text-[#05bdd9] mb-[10px]"
      />
      <div
        className={classNames(
          "font-[900]",
          "text-[22px]",
          "text-active-black tracking-[0.44px]"
        )}
      >
        Premium Subscriptions
      </div>
      <div className="text-[18px] mt-[12px] mb-[11px]">
        Premium Subscriptions are add-on subscriptions providing high-touch
        access to Insight Providers &amp; their specialist services.
      </div>

      {profile.showPremiumServicesTab ? (
        <Link
          href={`/${profile.isCompany ? "companies" : "profiles"}/${
            profile.slug
          }/premium-subscriptions`}
          className="text-[16px] font-bold text-smart-teal hover:text-[#00b5d0]"
        >
          {"More Information »"}
        </Link>
      ) : (
        <PremiumServiceButton
          profile={profile}
          className={classNames(
            "border border-solid border-smart-teal rounded-full",
            "w-full h-[38px]",
            "text-smart-teal text-[16px] font-bold bg-white hover:text-white hover:bg-smart-teal"
          )}
        >
          {!showCTA && (
            <FontAwesomeIcon icon={faGem} className="text-[16px] text-white" />
          )}{" "}
          Request Information/Trial
        </PremiumServiceButton>
      )}
    </div>
  );
};

export default PremiumServiceWidget;
